(function () {
    angular.module('tmx-app').service('ProgressBar', ['tmxUtility', 
        function progressBar(tmxUtility) {
        
            var requesters = new Map([]);
            var service = this;
            function getHideFunc(id){
                return function () {
                    requesters.delete(id);
                };
            }
            service.show = function (id) {
                if (!id)
                    id = tmxUtility.generateGuid();
                requesters.set(id, true);
                return getHideFunc(id);
            };
            service.hide = function (id) {
                getHideFunc(id)();
            };
            service.isVisible = function () {
                return requesters.size > 0 ? true : false;
            };
        }]);
})();